import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "p-ml-3" }, " Calendario ", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("+")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "p-ml-3 p-mr-3 p-text-center" }, " Ricorda! Gli ordini possono essere inseriti con almeno 30 ore di anticipo ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_FullCalendar = _resolveComponent("FullCalendar")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_router_link, {
      style: {"width":"75px","height":"75px","font-size":"7em"},
      to: "/csac/add",
      class: "fab"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_Card, { class: "p-ml-3 p-mr-3 p-p-1 p-shadow-3" }, {
      content: _withCtx(() => [
        _createVNode(_component_FullCalendar, {
          options: {
                    ..._ctx.calendarOptions,
                    events: _ctx.events
                }
        }, null, 8 /* PROPS */, ["options"])
      ]),
      _: 1 /* STABLE */
    }),
    _hoisted_3
  ], 64 /* STABLE_FRAGMENT */))
}